import React from 'react'
import { Dialog } from 'primereact/dialog'
import { Dropdown } from 'primereact/dropdown'
import { Button } from 'primereact/button'
import { InputText } from 'primereact/inputtext'

const CreateTicketModal = ({
  visible,
  onHide,
  departments,
  selectedDept,
  setSelectedDept,
  title,
  setTitle,
  onSubmit,
}: {
  visible: boolean
  onHide: () => void
  departments: any[]
  selectedDept: any
  setSelectedDept: (val: any) => void
  title: string
  setTitle: (val: string) => void
  onSubmit: () => void
}) => {
  return (
    <Dialog header="Create New Ticket" visible={visible} style={{ width: '600px' }} onHide={onHide}>
      <div style={{ marginBottom: 16 }}>
        <InputText
          value={title}
          onChange={(e) => setTitle(e.target.value)}
          placeholder="Title"
          style={{ width: '100%' }}
        />
      </div>

      <div style={{ marginBottom: 16 }}>
        <Dropdown
          value={selectedDept}
          options={departments}
          onChange={(e) => setSelectedDept(e.value)}
          placeholder="Select A department"
          style={{ width: '100%' }}
        />
      </div>

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 12 }}>
        <Button label="Cancel" className="p-button-text" onClick={onHide} />
        <Button label="Submit" className="p-button-info" onClick={onSubmit} />
      </div>
    </Dialog>
  )
}

export default CreateTicketModal
